import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// CATALAN
import caCommon from './locales/ca/common.json';
import caSurvey from './locales/ca/survey.json';

// ESPANOL
import esCommon from './locales/es/common.json';
import esSurvey from './locales/es/survey.json';

// INGLES
import enCommon from './locales/en/common.json';
import enSurvey from './locales/en/survey.json';

// FRANCES
import frCommon from './locales/fr/common.json';
import frSurvey from './locales/fr/survey.json';

const resources = {
    ca: {
        common: caCommon,
        survey: caSurvey,
    },
    es: {
        common: esCommon,
        survey: esSurvey,
    },
    en: {
        common: enCommon,
        survey: enSurvey,
    },
    fr: {
        common: frCommon,
        survey: frSurvey,
    },
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: "ca",
        fallbackLng: "ca",
        ns: ['common', 'survey'],
        defaultNS: 'common',
        interpolation: {
            escapeValue: false,
        },
        debug: false,
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
    });

export default i18n;
